import { IntegrityMonitorCustomRuleActionsFormWebComponent } from './component/IntegrityMonitorCustomRuleActionsFormWebComponent';
import { WEB_COMPONENT_INTEGRITY_MONITOR_RULES_CUSTOM_RULE_ACTIONS_FORM } from '../../../../webcomponents.constants';

export { IntegrityMonitorCustomRuleActionsFormWebComponent };

window.customElements.define(
  WEB_COMPONENT_INTEGRITY_MONITOR_RULES_CUSTOM_RULE_ACTIONS_FORM,
  IntegrityMonitorCustomRuleActionsFormWebComponent
);
